export enum ESubappNames {
  STANDARD = 'standard',
  KOOICK = 'kooick',
  SMARTCAFE = 'smartcafe',
  GO = 'go',
  SEED = 'seed',
  SANDSTAR = 'sandstar',
  VENDSYS = 'vendsys',
  SEN = 'sen',
  GOMINI = 'gomini',
}

/**
 * Ordered palette of APP_SEMANTIC-compatible color tokens.
 * Rules:
 *   - No green / red / gray (reserved for status signals).
 *   - Each entry is perceptually distinct from its neighbors.
 *   - Add new tokens here when more colors are needed.
 * Blocked: green, red, gray (status signals), pink/rose, teal.
 */
const SUBAPP_PALETTE = [
  'blue',    // medium blue
  'purple',  // violet-purple
  'orange',  // warm orange
  'indigo',  // deep blue-indigo
  'warning', // amber / gold
  'sky',     // light cornflower blue
  'cyan',    // vivid cyan
  'info',    // electric blue-indigo
  'fuchsia', // vivid magenta-purple
] as const;

/**
 * Deterministic djb2-style hash → palette index.
 * Same name always returns the same color, independent of registration order.
 */
function hashToPaletteIndex(name: string): number {
  let hash = 5381;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 33) ^ name.charCodeAt(i);
    hash = hash >>> 0; // keep 32-bit unsigned
  }
  return hash % SUBAPP_PALETTE.length;
}

/**
 * Returns a stable, distinct color token for a sub-application name.
 * - Deterministic: same name → same color on every call / page.
 * - No manual mapping needed when new subapps are added.
 * - Never returns green, red, or gray.
 */
export const getColorForSubApplication = (name: string): string => {
  if (!name) return 'gray';
  return SUBAPP_PALETTE[hashToPaletteIndex(name.toLowerCase())];
};
